module.exports = __webpack_public_path__ + "7b249f565cc9aa70b36bcdee11fd25e0.svg";